// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Oy4zQIJBH20VJ_0MbEZH{--titled-row-action-width:190px;flex-direction:column;gap:36px;display:flex}.lg58J1_MKgF5T1CRhKPd{width:100%}.XmYXKBcSQkvfBFre_mEU{--dropdown-checked-margin-left:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Oy4zQIJBH20VJ_0MbEZH`,
	"select": `lg58J1_MKgF5T1CRhKPd`,
	"dropdown": `XmYXKBcSQkvfBFre_mEU`
};
export default ___CSS_LOADER_EXPORT___;
